module.exports = __webpack_public_path__ + "img/oikonomiki-stirixi-logo.6db819aa.svg";